import Reveal from './Reveal';
import { useState } from 'react';

export default function SiteFooter({ onNavigate }) {
  const year = new Date().getFullYear();
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState('idle'); // idle | sending | sent | invalid | error
  const [newsletterErr, setNewsletterErr] = useState('');

  const submitNewsletter = async (e) => {
    e.preventDefault();
    const email = newsletterEmail.trim();
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      setNewsletterStatus('invalid');
      setNewsletterErr('Please enter a valid email address.');
      return;
    }
    setNewsletterStatus('sending'); setNewsletterErr('');
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/newsletter-welcome`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
            'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
          },
          body: JSON.stringify({ email }),
        }
      );
      const json = await res.json().catch(() => ({}));
      if (!res.ok && json.error && !json.error.includes('already')) {
        setNewsletterStatus('error');
        setNewsletterErr('Something went wrong on our end. DM us on Instagram and we will add you manually.');
        return;
      }
    } catch {
      setNewsletterStatus('error');
      setNewsletterErr('Something went wrong on our end. DM us on Instagram and we will add you manually.');
      return;
    }
    setNewsletterStatus('sent');
    setNewsletterEmail('');
  };

  const col = (heading, items) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <p style={{
        fontFamily: 'Inter, sans-serif', fontSize: 10, fontWeight: 700,
        letterSpacing: '0.18em', textTransform: 'uppercase',
        color: 'rgba(255,255,255,0.3)', margin: 0,
      }}>
        {heading}
      </p>
      {items.map(({ label, action, href }) =>
        href ? (
          <a
            key={label} href={href} target="_blank" rel="noopener noreferrer"
            style={{ fontFamily: 'Inter, sans-serif', fontSize: 14, color: 'rgba(255,255,255,0.65)', textDecoration: 'none', transition: 'color 0.2s' }}
            onMouseEnter={e => e.target.style.color = '#fff'}
            onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.65)'}
          >
            {label}
          </a>
        ) : (
          <button
            key={label} onClick={action}
            style={{
              background: 'none', border: 'none', cursor: action ? 'pointer' : 'default',
              fontFamily: 'Inter, sans-serif', fontSize: 14, color: action ? 'rgba(255,255,255,0.65)' : 'rgba(255,255,255,0.25)',
              textAlign: 'left', padding: 0, transition: 'color 0.2s',
            }}
            onMouseEnter={e => { if (action) e.target.style.color = '#fff'; }}
            onMouseLeave={e => { if (action) e.target.style.color = 'rgba(255,255,255,0.65)'; }}
          >
            {label}
          </button>
        )
      )}
    </div>
  );

  const igBtn = {
    display: 'inline-flex', alignItems: 'center', gap: 8,
    padding: '11px 22px',
    background: '#9D1515',
    color: '#fff',
    fontFamily: 'Inter, sans-serif', fontSize: 12, fontWeight: 700,
    letterSpacing: '0.1em', textTransform: 'uppercase',
    textDecoration: 'none',
    transition: 'background 0.15s',
  };
  const fbBtn = {
    display: 'inline-flex', alignItems: 'center', gap: 8,
    padding: '11px 22px',
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.15)',
    color: 'rgba(255,255,255,0.7)',
    fontFamily: 'Inter, sans-serif', fontSize: 12, fontWeight: 700,
    letterSpacing: '0.1em', textTransform: 'uppercase',
    textDecoration: 'none',
    transition: 'border-color 0.15s, color 0.15s',
  };

  return (
    <Reveal as="footer" variant="fade" style={{ background: '#080808', borderTop: '1px solid rgba(255,255,255,0.06)' }}>

      {/* Follow the Revival */}
      <div style={{ borderBottom: '1px solid rgba(255,255,255,0.06)', padding: '72px 24px', textAlign: 'center' }}>
        <p style={{ fontFamily: 'Inter, sans-serif', fontSize: 10, fontWeight: 700, letterSpacing: '0.26em', color: '#9D1515', textTransform: 'uppercase', margin: '0 0 16px' }}>
          Stay Connected
        </p>
        <h2 style={{ fontFamily: "'Bebas Neue','Oswald',sans-serif", fontSize: 'clamp(40px, 7vw, 72px)', color: '#fff', letterSpacing: '0.04em', margin: '0 0 18px', lineHeight: 1 }}>
          FOLLOW THE REVIVAL
        </h2>
        <p style={{ fontFamily: 'Inter, sans-serif', fontSize: 14, color: 'rgba(255,255,255,0.4)', lineHeight: 1.75, maxWidth: 460, margin: '0 auto 28px' }}>
          Join our newsletter for first dibs on drop-in dates, drop-in availability, tournament drops, and seasonal events.
        </p>

        <form onSubmit={submitNewsletter} style={{
          display: 'flex', gap: 8, maxWidth: 460, margin: '0 auto 28px',
          flexWrap: 'wrap', justifyContent: 'center',
        }}>
          <input
            type="email"
            value={newsletterEmail}
            onChange={e => setNewsletterEmail(e.target.value)}
            placeholder="your@email.com"
            disabled={newsletterStatus === 'sending' || newsletterStatus === 'sent'}
            style={{
              flex: '1 1 220px',
              padding: '12px 14px',
              background: '#0e0e0e',
              border: '1px solid #2a2a2a',
              color: '#fff',
              fontFamily: 'Inter, sans-serif', fontSize: 13,
              outline: 'none',
            }}
          />
          <button
            type="submit"
            disabled={newsletterStatus === 'sending' || newsletterStatus === 'sent'}
            style={{
              background: newsletterStatus === 'sent' ? '#4ade80' : '#9D1515',
              color: '#fff', border: 'none',
              fontFamily: "'Bebas Neue','Oswald',sans-serif",
              fontSize: 13, letterSpacing: '0.16em',
              padding: '12px 22px',
              cursor: (newsletterStatus === 'sending' || newsletterStatus === 'sent') ? 'default' : 'pointer',
              transition: 'background 0.15s',
            }}
          >
            {newsletterStatus === 'sent' ? '✓ SUBSCRIBED' : newsletterStatus === 'sending' ? 'SENDING…' : 'NOTIFY ME'}
          </button>
        </form>
        {(newsletterStatus === 'invalid' || newsletterStatus === 'error') && (
          <p style={{ fontSize: 12, color: '#ff6b6b', marginTop: -16, marginBottom: 16 }}>
            {newsletterErr}
          </p>
        )}

        <p style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, color: 'rgba(255,255,255,0.3)', margin: '0 0 14px' }}>
          Or follow us on social
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a
            href="https://www.instagram.com/ovrleague"
            target="_blank" rel="noopener noreferrer"
            style={igBtn}
            onMouseEnter={e => e.currentTarget.style.background = '#c41e1e'}
            onMouseLeave={e => e.currentTarget.style.background = '#9D1515'}
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
            Instagram
          </a>
          <a
            href="https://www.facebook.com/ovrleague"
            target="_blank" rel="noopener noreferrer"
            style={fbBtn}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.4)'; e.currentTarget.style.color = '#fff'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)'; e.currentTarget.style.color = 'rgba(255,255,255,0.7)'; }}
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
            </svg>
            Facebook
          </a>
        </div>
      </div>

      {/* Main grid */}
      <div style={{
        maxWidth: 1100, margin: '0 auto', padding: '60px 24px 40px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: '40px 32px',
      }}>
        {col('League', [
          { label: 'Upcoming Events', action: () => onNavigate('UPCOMING EVENTS') },
          { label: 'Tournaments',     action: () => onNavigate('TOURNAMENTS') },
          { label: 'Drop Ins',        action: null },
          { label: 'Gallery',         action: () => onNavigate('GALLERY') },
          { label: 'Sponsors',        action: () => onNavigate('SPONSORS') },
        ])}
        {col('Company', [
          { label: 'About Us',        action: () => onNavigate('ABOUT US') },
          { label: 'Contact Us',      href: '/contact' },
          { label: 'Merch',           action: null },
        ])}
        {col('Social', [
          { label: '@ovrleague',              href: 'https://www.instagram.com/ovrleague' },
          { label: '@horizoneventsofficial',  href: 'https://www.instagram.com/horizoneventsofficial' },
        ])}
        {col('Contact', [
          { label: 'Ottawa, Ontario',    action: null },
          { label: 'Contact Form',       href: '/contact' },
          { label: 'DM us on Instagram', href: 'https://www.instagram.com/ovrleague' },
        ])}
      </div>

      {/* Divider */}
      <div style={{ height: 1, background: 'rgba(255,255,255,0.05)', maxWidth: 1100, margin: '0 auto' }} />

      {/* Bottom bar */}
      <style>{`
        .footer-bottom { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12; }
        .footer-legal { display: flex; gap: 20; }
        @media (max-width: 600px) {
          .footer-bottom { flex-direction: column; align-items: flex-start; }
          .footer-legal { border-top: 1px solid rgba(255,255,255,0.06); padding-top: 12px; width: 100%; }
          .footer-legal-wrap { padding-bottom: 72px !important; }
        }
      `}</style>
      <div className="footer-legal-wrap footer-bottom" style={{ maxWidth: 1100, margin: '0 auto', padding: '20px 24px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <img
            src={'/ovr-logo.png'}
            alt="OVR"
            style={{ height: 28, width: 'auto', opacity: 0.7 }}
          />
          <span style={{ fontFamily: 'Inter, sans-serif', fontSize: 12, color: 'rgba(255,255,255,0.25)' }}>
            © {year} Ottawa Volleyball Revival. All rights reserved.
          </span>
        </div>
        <div className="footer-legal">
          {[
            { label: 'Privacy Policy', href: '/privacy' },
            { label: 'Terms of Use',   href: '/terms' },
          ].map(({ label, href }) => (
            <a
              key={label} href={href}
              style={{
                fontFamily: 'Inter, sans-serif', fontSize: 12,
                color: 'rgba(255,255,255,0.4)', textDecoration: 'none',
                transition: 'color 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.color = '#fff'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.4)'}
            >
              {label}
            </a>
          ))}
        </div>
      </div>
    </Reveal>
  );
}
